export const environment = {
    production: false,
    apiUrl: 'https://api.hom.lxview.lxtech.com.br'
}